module.exports = __webpack_public_path__ + "static/media/nuevoProyecto.8403dbe0.png";